import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import BadgeNew from "../../BadgeNew";

import { sendNavigationMetric } from "../../../utils/sendMetric";

import { useStore } from "../../../connect";

import allServicesLinks from "../../../links/allServicesLinks";

import styles from "../AllServices.scss";

const cx = classnames.bind(styles);

const ServiceLink = ({ name, isNew }) => {
  const { profile } = useStore();

  const data = allServicesLinks[name] || {};

  return (
    <a
      className={cx("service-link", { "is-new": isNew })}
      href={
        !profile.isLoggedIn && data.anonimHref ? data.anonimHref : data.href
      }
      rel="noreferrer noopener"
      target="_blank"
      onClick={() => sendNavigationMetric(data.code)}
    >
      <div className={cx("service-link-icon")}>
        <img
          className={cx("icon-img")}
          src={data.iconSource}
          alt={data.label}
        />
      </div>
      <div className={cx("service-link-text")}>
        <span className={cx("service-link-label")}>
          {data.label}
          {isNew && <BadgeNew />}
        </span>
      </div>
    </a>
  );
};

ServiceLink.propTypes = {
  name: PropTypes.string,
  isNew: PropTypes.bool,
};

export default observer(ServiceLink);
